<ol>
  <li>
    Zapoznałem/am się z regulaminem e-usługi: <strong>{{ application?.regulations ? 'Tak' : 'Nie' }}</strong>
  </li>
  <li>
    Zapoznałem/am się z klauzulą informacyjną RODO: <strong>{{ application?.clause ? 'Tak' : 'Nie' }}</strong>
  </li>
</ol>
